import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default function () {
  const heroVideoBlocks = document.querySelectorAll('.js-heroVideoBlock');
  if (!heroVideoBlocks) return;

  const isMobile = window.innerWidth <= 1023;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  heroVideoBlocks.forEach((section) => {
    const bgVideo = section.querySelector('.js-heroVideoBlock__bg-black');
    const video = section.querySelector('.js-heroVideoBlock__video');
    const videoTag = document.querySelector('.js-heroVideoBlock__videoTag');

    if (!prefersReducedMotion && !isMobile) {
      videoTag.play();
    }

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom center',
      ease: 'none',
      pin: video
    });

    gsap.fromTo(
      bgVideo,
      {
        opacity: 0.3
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom center',
          ease: 'none',
          scrub: true,
          markers: false
        }
      }
    );
  });
}
